import { useHistory } from 'react-router-dom';
import { getLastSegmentFromPath, apiPost, apiPatch, apiGet, apiDelete } from '../utils';

const useTransaction = () => {
    const history = useHistory();
    const urlPrefix = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/api/user/transactions`;

    const postTransactionLast = async (myAccountId, type, currentState) => {
        const url = `${urlPrefix}/last`;
        const data = {
            myAccountId,
            type,
            currentState
        };
        return await apiPost(url, data);
    };

    const postTransactionStart = async (myAccountId, type, currentState) => {
        const url = `${urlPrefix}`;
        const data = {
            myAccountId,
            type,
            currentState
        };
        return await apiPost(url, data);
    };

    const postTransactionState = async () => {
        const transactionId = localStorage.getItem('transactionId');
        const url = `${urlPrefix}/${transactionId}/state`;
        const dataKey = getLastSegmentFromPath(location.pathname); // e.g. personal-details-page
        const data = {
            to: dataKey
        };
        return await apiPost(url, data);
    };

    const patchTransactionStatus = async (id, status) => {
        const url = `${urlPrefix}/${id}/status?status=${status}`;
        return await apiPatch(url);
    };

    const postTransactionSave = async (data) => {
        const transactionId = localStorage.getItem('transactionId');
        const dataKey = getLastSegmentFromPath(location.pathname); // e.g. personal-details-page
        const url = `${urlPrefix}/${transactionId}/data/key/${dataKey}`;
        return await apiPost(url, data);
    };

    const getTransactionSaved = async (transactionId, key) => {
        const url = `${urlPrefix}/${transactionId}/data/key/${key}`;
        return await apiGet(url);
    };

    const getTransactionAll = async (id) => {
        const url = `${urlPrefix}/${id}/data`;
        return await apiGet(url);
    };

    const deleteTransaction = async () => {
        const transactionId = localStorage.getItem('transactionId');
        if (transactionId) {
            const url = `${urlPrefix}/${transactionId}/data`;
            return await apiDelete(url);
        }
        return null;
    };

    const saveDetails = async (details, gotoPage) => {
        await postTransactionSave(details);
        await postTransactionState();
        history.push(gotoPage);
    };

    const loadDetails = async (functionSaveDetails) => {
        const currentState = getLastSegmentFromPath(window.location.pathname);
        const transactionId = localStorage.getItem('transactionId');
        const savedData = await getTransactionSaved(transactionId, currentState);

        if (savedData) {
            await functionSaveDetails(savedData);
        }
    };

    return {
        postTransactionLast,
        postTransactionStart,
        postTransactionState,
        patchTransactionStatus,
        postTransactionSave,
        getTransactionSaved,
        getTransactionAll,
        deleteTransaction,
        saveDetails,
        loadDetails
    };
};

export default useTransaction;
